
<app-navbar></app-navbar>
<!-- Main Content -->
<app-toast></app-toast>
<router-outlet></router-outlet>
